import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    other_user: {

    },
  },
  getters: {
    other_user: ({other_user}) => other_user,
  },
  mutations: {
    SET_OTHER_USER(state, value) {
      state.other_user = value;
    },
  },
  actions: {
    async get_other_user({commit}, id) {
      try {
        let other_user = await api.user.load_user(id);
        commit('SET_OTHER_USER', other_user.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};

